import { render, staticRenderFns } from "./tax.vue?vue&type=template&id=d11cd220&scoped=true&"
import script from "./tax.vue?vue&type=script&lang=js&"
export * from "./tax.vue?vue&type=script&lang=js&"
import style0 from "./tax.vue?vue&type=style&index=0&id=d11cd220&prod&lang=scss&scoped=true&"
import style1 from "./tax.vue?vue&type=style&index=1&id=d11cd220&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11cd220",
  null
  
)

export default component.exports